// extracted by mini-css-extract-plugin
module.exports = {"fiveColBreakPoint":"1411","fourColBreakPoint":"1066","threeColBreakPoint":"757"};